<!-- Shows the certificates avaiable to a given product. Meaning you should be able to view all the certificates issued to you under a given product(crop)-->
<template>
    <div id="landOwnerDashBox">
        <h2 orientation="left">
            Certificates
        </h2>

        <table class="w-full pr-5 pl-5">
            <thead>
                <tr>
                    <th>Certificate ID</th>
                    <th>Date issued</th>
                    <th>Product</th>
                    <th>Land area</th>
                </tr>
            </thead>
            <tr v-for="(eachCert, key) in certificateData" :key="'certs' + key">
                <td>
                    <router-link
                        :to="{
                            name: 'view-land-record',
                            params: { id: eachCert.id }
                        }"
                    >
                        <!-- eslint-disable-next-line -->
                        {{ eachCert.certificateID }}
                        <!-- eslint-disable-next-line -->
                    </router-link>
                </td>
                <td>{{ dateTimeFormatter(eachCert.dateIssued) }}</td>
                <td>{{ eachCert.productType }}</td>
                <td>{{ eachCert.landAreaInM2 }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    name: "ViewProductCertificatesView",
    created() {
        //this.$form.props.layout = "horizontal";
        //console.log(this.$form)
    },
    data() {
        return {
            certificateData: [
                {
                    id: 0,
                    certificateID: "C20180419-AAA6-BKKH-HHHRMB2",
                    dateIssued: "2019-01-12",
                    productType: "Corn",
                    landAreaInM2: "638042.43"
                },
                {
                    id: 1,
                    certificateID: "C20190419-AAA6-BAAH-RRRRMB2",
                    dateIssued: "2019-04-19",
                    productType: "Wheat",
                    landAreaInM2: "628042.43"
                },
                {
                    id: 2,
                    certificateID: "C20180411-AAA6-UUUH-RRRRMB2",
                    dateIssued: "2018-04-11",
                    productType: "Wheat",
                    landAreaInM2: "668442.43"
                },
                {
                    id: 3,
                    certificateID: "C20180319-AAA6-MMMH-RRRRMB2",
                    dateIssued: "2018-03-19",
                    productType: "Corn",
                    landAreaInM2: "418342.43"
                },
                {
                    id: 4,
                    certificateID: "C20170419-AAA6-RRRH-RRRRMB2",
                    dateIssued: "2017-04-19",
                    productType: "Soy",
                    landAreaInM2: "246772.43"
                }
            ]
        };
    },
    methods: {
        dateTimeFormatter(dataIn) {
            return this.$dateFns.format(new Date(dataIn), "Do-MMMM-YYYY", {
                locale: this.$dateFns.locale
            });
        },
        convertKGWeight(valInKGIn, convertTo) {
            return valInKGIn + " " + convertTo;
        },
        handleTableChange() {}
    },
    components: {}
};
</script>
<style>
#landOwnerDashBox {
    padding: 15px 15px;
}
</style>
